import {
    PortfolioCentralPaymentPoliciesGetParameters,
    PortfolioCentralPaymentPolicyOverviewEntry,
    useRepositoryQuery,
} from '@mews-commander/data-access';
import { TableState } from '@optimus-web/core';

export const useCentralPaymentPoliciesGetOverview = (
    tableState: TableState<PortfolioCentralPaymentPolicyOverviewEntry>
) => useRepositoryQuery('portfolioCentralPaymentPolicies', 'getOverviewEntries', tableState);

export const useCentralPaymentPoliciesGet = (
    params: PortfolioCentralPaymentPoliciesGetParameters,
    options = { enabled: true }
) =>
    useRepositoryQuery('portfolioCentralPaymentPolicies', 'get', params, {
        enabled: options.enabled,
    });
